import { put, call, takeLatest, select } from 'redux-saga/effects';

import { ADVOCACY_STATUS_QUERY_KEY } from 'hooks/linkedinAdvocacy/useAdvocacyStatus';
import { disconnectLinkedin, getLinkedinConnectionStatus } from 'services/linkedin';
import { AsyncAction } from 'types/Action';
import { DisconnectLinkedinMeta, DisconnectLinkedinPayload } from 'types/store/DisconnectLinkedin';
import { Store } from 'types/store/Store';
import { queryClient } from 'utils/QueryClient';

import { disconnectLinkedinActions, getLinkedinConnectionStatusActions } from '../actions';

export function* disconnectLinkedinRequest(action: AsyncAction<DisconnectLinkedinMeta, DisconnectLinkedinPayload>): any {
  const state: Store = yield select();
  if (state.auth.token) {
    try {
      const {data}  = yield call(disconnectLinkedin, action.meta, state.auth.token);
      yield put(disconnectLinkedinActions.success(data));
      // The shell stays mounted, so the reconnect banner would otherwise keep
      // asking to renew the connection just removed.
      yield call([queryClient, queryClient.cancelQueries], ADVOCACY_STATUS_QUERY_KEY);
      yield call([queryClient, queryClient.invalidateQueries], ADVOCACY_STATUS_QUERY_KEY);
    } catch (e: any) {
      yield put(disconnectLinkedinActions.failed(e.message));
    }
  }
}

function* disconnectLinkedinSuccess(action: AsyncAction<DisconnectLinkedinMeta, DisconnectLinkedinPayload>): any {
  const dataFailed = {
    data: {
      status: 'DISCONNECTED',
    },
    status: 400,
    message: 'LinkedIn disconnected successfully',
  };
  yield put(getLinkedinConnectionStatusActions.success(dataFailed));
}

function* disconnectLinkedinWatcher(): any {
  yield takeLatest(disconnectLinkedinActions.REQUEST, disconnectLinkedinRequest);
  yield takeLatest(disconnectLinkedinActions.SUCCESS, disconnectLinkedinSuccess);
}

export default disconnectLinkedinWatcher;
